export const sanitizeDemoMediaUrl = (url) => {
  const normalizedUrl =
    String(url || "").trim()

  if (!normalizedUrl) return ""

  if (normalizedUrl.includes("picsum.photos/seed/farasod-")) {
    return ""
  }

  return normalizedUrl
}

export const getSelectedItemsBySpecificationId = (
  selectedSpecificationItems,
  specificationId,
  builderStepKey
) =>
  selectedSpecificationItems.filter(item =>
    String(item.specificationId) === String(specificationId) &&
    (!builderStepKey || item.builderStepKey === builderStepKey)
  )

export const getSelectedSpecificationTotal = (
  selectedSpecificationItems
) =>
  selectedSpecificationItems.reduce((total, item) =>
    total +
    ((item.salePrice || 0) * ((item.quantity || 1) - (item.freeQuantity || 0))),
    0
  )

export const isCustomBuilderStepValid = (
  step,
  selectedSpecificationItems
) => {
  if (step.uiMode === "summary") return true

  const selectedItems =
    getSelectedItemsBySpecificationId(
      selectedSpecificationItems,
      step.specificationId,
      step.key
    )

  const selectedCount =
    selectedItems.reduce((sum, item) =>
      sum + (item.quantity || 1),
      0
    )
  const minSelect =
    Number(step.minSelect) || 0
  const requiredMinSelect =
    step.isRequired
      ? Math.max(minSelect, 1)
      : minSelect

  if (step.isRequired && selectedCount < requiredMinSelect) {
    return false
  }

  if (!step.isRequired && selectedCount === 0) {
    return true
  }

  if (selectedCount < requiredMinSelect) return false

  if (step.maxSelect > 0 && selectedCount > step.maxSelect) return false

  return true
}

export const isCustomBuilderComplete = (
  customBuilder,
  selectedSpecificationItems
) => {
  if (!customBuilder?.enabled) return true

  return (customBuilder.steps || []).every(step =>
    isCustomBuilderStepValid(step, selectedSpecificationItems)
  )
}
